import { render, staticRenderFns } from "./AssignComponent.vue?vue&type=template&id=d51b7e4c&scoped=true"
import script from "./AssignComponent.vue?vue&type=script&lang=js"
export * from "./AssignComponent.vue?vue&type=script&lang=js"
import style0 from "./AssignComponent.vue?vue&type=style&index=0&id=d51b7e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51b7e4c",
  null
  
)

export default component.exports